import { ElMessage } from 'element-plus';
import { IFileData } from '../types';

/**
 * 校验上传的文件后缀格式 和 文件大小【默认20MB】；
 * 【注意】只是校验后缀名而已，并非严格的格式校验，例如 .jpg 和 .jpeg 会判断为不同文件后缀而校验失败；
 * 【使用】只作为一个辅助方法在 beforeUpload 时校验
 * @param file
 * @param fileType
 * @returns boolean
 */
export default function checkFile(
  file: IFileData,
  extensionArr: string | string[],
  sizeLimit: string | number = 20,
) {
  const extension = '.'.concat(file.name?.split('.').pop() ?? '');
  const extensionList = typeof extensionArr === 'string'
    ? extensionArr.split(',').map(v => v.trim())
    : extensionArr;
  const isAllowExtension = extensionList.includes(extension);
  if (!isAllowExtension) ElMessage.warning('文件格式有误！');

  const isSizeLimit = Number(file.size) / 1024 / 1024 < parseFloat(`${sizeLimit}`);
  if (!isSizeLimit) ElMessage.warning('文件大小超出限制！');

  return isAllowExtension && isSizeLimit;
}
